const NS = "RELEX/HOME";

export const LOGIN = `${NS}/LOGIN`;
export const UPDATE_USER_TOKEN = `${NS}/UPDATE_USER_TOKEN`;
export const LOGOUT = `${NS}/LOGOUT`;
export const GO_TO_HOME = `${NS}/GO_TO_HOME`;
export const EDIT_USER = `${NS}/EDIT_USER`;
